module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QIUCQgmoXLFVQAAAMdJREFUSMftkzEOgkAQRd8sljZ6Bg/gCTyFrRU0NgLGHhNrIcRSE6McwhN4BTuuoIU1rIUmWogYEWOxr53Z/+fPZMFgMPwt0cge1KHbKCpokS2QhK49A/FAwnG8DGozvCMu0AS80LcTctkBnSeNmYa9zrPhZLE+FKmpNwwj4KxFR+TSLzADsAR6SlmbSglvawwA5p4zFV06YbeSYeQ6Rw2t62Grn0n9zbcIXUfXoSvfNhQ4+fGq/bOEZe/Ui0nTDxOmGAwGwyMXk0g05OlM/hsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/6.png
// module id = q+Bo
// module chunks = 0